import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAgentStatusLimits } from '../api';
import { useSelector } from '../hook-utils';
import { actions } from '../store';
import { selectAgentStats } from '../store/reducers/agentStats';
import { selectAgentStatsModal } from '../store/reducers/modals';
import './AgentChartsPopup.scss';
import { AgentCharts } from './AgentView/Dashboard';
import Modal from './Modal';

export default function AgentChartsPopup() {
  const dispatch = useDispatch()
  const id = useSelector(selectAgentStatsModal)
  const [lastId, setLastId] = useState(id)
  const stats = useSelector(s => lastId ? selectAgentStats(s, lastId) : undefined)

  useEffect(() => {
    if (id) {
      setLastId(id)
    }
  }, [id])

  useEffect(() => {
    load()

    async function load() {
      if (!id) { return }

      const data = await getAgentStatusLimits(id, 'on')
      dispatch(actions.loadAgentStats(id, data))
    }

    return () => {
      if (!id) { return }
      getAgentStatusLimits(id, 'off')
      dispatch(actions.loadAgentStats(id, undefined))
    }
  }, [dispatch, id])

  return <Modal isOpen={Boolean(id)} onRequestClose={() => dispatch(actions.openAgentStats(null))}>
    <Modal.Header>Agent stats</Modal.Header>
    <div className='AgentStatsPopup'>
      {stats === undefined ? <div className='message'>Loading...</div>
        : stats === null ? <div className='message'>No data</div>
          : <AgentCharts stats={stats} />}
    </div>
  </Modal>
}
